import React, { useMemo, useState } from "react";
import "../login/login.css";
import { PCB_CORE_URL } from "../../config";

const API_FORGOT = `${PCB_CORE_URL}/forgot-password/`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const canSubmit = useMemo(() => {
    return email.trim().length > 3 && !loading;
  }, [email, loading]);

  async function handleSubmit(e) {
    e.preventDefault();
    setServerError("");
    setSuccessMsg("");
    if (!canSubmit) return;

    setLoading(true);
    try {
      const res = await fetch(API_FORGOT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          data?.detail || data?.message || data?.Message || "Une erreur est survenue.";
        throw new Error(msg);
      }

      setSuccessMsg(
        data?.message ||
          "Si un compte actif existe avec cet email, un lien de réinitialisation a été envoyé."
      );
    } catch (err) {
      setServerError(err.message || "Erreur lors de l'envoi.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">Mot de passe oublié</h1>
          <p className="auth-subtitle">
            Entrez votre email pour recevoir un lien de réinitialisation.
          </p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label">
            Email
            <input
              className="auth-input"
              type="email"
              autoComplete="email"
              placeholder="ex: nour@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading || !!successMsg}
              required
            />
          </label>

          {serverError ? <div className="auth-alert error">{serverError}</div> : null}
          {successMsg ? <div className="auth-alert success">{successMsg}</div> : null}

          {!successMsg && (
            <button className="auth-btn" type="submit" disabled={!canSubmit}>
              {loading ? "Envoi en cours..." : "Envoyer le lien"}
            </button>
          )}

          <div className="auth-footer">
            <span>Retour à la</span>
            <a className="auth-link" href="/login">
              connexion
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
